export default __webpack_public_path__ + "static/media/uv44_kr_head_a1.67f62077.mp3";